import { useState } from 'react'

// The Okoiya ring "O" with a white check — the verification motif.
function OkoiyaRing({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ display:'block', flexShrink:0 }}>
      <circle cx="12" cy="12" r="10" fill="#C4826A" />
      <path d="M7.5 12.4l3 3 6-6.6" fill="none" stroke="#fff" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const TOOLTIP =
  "Okoiya Verified means our team has reviewed this vendor's business registration, portfolio, and at least 3 references from real weddings."

/**
 * VerifiedBadge — renders only for verified/pending vendors.
 *  • verified → terracotta Okoiya ring + "Verified" pill, with a hover/tap tooltip
 *  • pending  → muted grey "Verification in progress" pill (no ring, no tooltip)
 *  • rejected / null → nothing
 */
export default function VerifiedBadge({ status, size = 22 }) {
  const [show, setShow] = useState(false)

  if (status === 'pending') {
    return (
      <span style={{
        display:'inline-flex', alignItems:'center', gap:'0.35rem',
        background:'#F3F0EA', border:'1px solid #E5E0D8', borderRadius:100,
        padding:'0.2rem 0.6rem', fontFamily:'Nunito Sans, sans-serif',
        fontSize:'0.7rem', fontWeight:600, color:'#9B9B9B', whiteSpace:'nowrap',
      }}>
        Verification in progress
      </span>
    )
  }

  if (status !== 'verified') return null

  return (
    <span
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShow(v => !v) }}
      style={{ position:'relative', display:'inline-flex', alignItems:'center', gap:'0.35rem',
        background:'#FFFDFA', border:'1px solid rgba(196,130,106,0.45)', borderRadius:100,
        padding:'0.2rem 0.55rem 0.2rem 0.3rem', cursor:'help', whiteSpace:'nowrap' }}
    >
      <OkoiyaRing size={size} />
      <span style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.7rem', fontWeight:700, color:'#C4826A' }}>Verified</span>
      {show && (
        <span role="tooltip" style={{
          position:'absolute', top:'calc(100% + 8px)', left:0, zIndex:50, width:240,
          background:'#1A1A1A', color:'#fff', borderRadius:'0.625rem', padding:'0.625rem 0.75rem',
          fontFamily:'Nunito Sans, sans-serif', fontSize:'0.72rem', fontWeight:400, lineHeight:1.55,
          boxShadow:'0 10px 30px rgba(0,0,0,0.25)', textAlign:'left',
        }}>
          {TOOLTIP}
        </span>
      )}
    </span>
  )
}
